import React, { PropsWithChildren } from 'react'
import { AnalyticsElement } from '@typesApp/Analytics'
import { useAppTranslation } from '@hooks/useAppTranslation'
import { useWebchat } from '@hooks/useWebchat'
import { IconButtonLink } from '@components/foundation/icon-button/IconButton'
import { injectAnalytics } from '@utils/analyticsAttributes'
import { injectDataAttributes } from '@utils/dataAttributes'
import styles from '../styles/ContactUsPanel.module.scss'

type ActionProps = {
  analyticsIndex: number
  noIcon?: boolean
  noPreLink?: boolean
} & PropsWithChildren

export const ChatAction: React.FC<ActionProps> = ({ analyticsIndex, noIcon, noPreLink, children }) => {
  const { t } = useAppTranslation()
  const { toggleWebchat } = useWebchat()

  const onClick = () => {
    toggleWebchat()
  }

  return (
    <IconButtonLink
      onClick={onClick}
      underline
      iconProps={noIcon ? undefined : { library: 'base', name: 'chat' }}
      preLink={noPreLink ? undefined : t('ContactInfo.chat-prelink')}
      preLinkClassName={noPreLink ? undefined : styles.preLink}
      {...injectDataAttributes('contactUs.chat')}
      {...injectAnalytics(AnalyticsElement.MORE_INFO, { index: analyticsIndex })}
    >
      {!children && <span className={styles.linkText}>{t('ContactInfo.chat')}</span>}
      {children}
    </IconButtonLink>
  )
}
